function multiSelectFilterFn( rows, id, filterValues ) {
	if ( filterValues.length === 0 ) {
		return rows;
	}

	return rows.filter( r => filterValues.includes( r.values[ id ] ) );
}

multiSelectFilterFn.autoRemove = val => !val;

export default multiSelectFilterFn;
